module.exports = __webpack_public_path__ + "img/buy_now_button.3aa1d4d9.png";